<form
  name="form"
  fxLayout="column"
  autocomplete="off"
  class="field-dialog__content__scroll tab-products p-24"
  fusePerfectScrollbar
>
  <div class="field-outline-form">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="12px">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>{{ 'MAINTENANCES.TABS.PRODUCTS.SEARCH_PLACEHOLDER' | translate }}</mat-label>
        <mat-icon matPrefix color="primary">search</mat-icon>
        <input matInput [formControl]="searchInputValue" (keydown)="$event.stopImmediatePropagation()" />
      </mat-form-field>
    </div>
  </div>

  <div class="tab-products__body">
    <p class="field-dialog__content__scroll__title">
      {{ 'MAINTENANCES.TABS.PRODUCTS.ATTACHED_PRODUCTS' | translate }} ({{
        (products && products.totalCount) || 0
      }}/150)
    </p>

    <div class="tab-services__body__value">
      <h4 class="tab-services__body__value__not-highlighted">
        {{ 'MAINTENANCES.TABS.PRODUCTS.PRODUCTS_VALUE' | translate }}
      </h4>
      <h4 class="tab-services__body__value__highlighted">R${{ maintenance.productsTotalValue || 0 | numberFormat }}</h4>
      <h4 class="tab-services__body__value__highlighted--sign">+</h4>
      <h4 class="tab-services__body__value__not-highlighted">
        {{ 'MAINTENANCES.TABS.PRODUCTS.SERVICES_VALUE' | translate }}
      </h4>
      <h4 class="tab-services__body__value__highlighted">R${{ maintenance.servicesTotalValue || 0 | numberFormat }}</h4>
      <h4 class="tab-services__body__value__highlighted--sign">=</h4>
      <h4 class="tab-services__body__value__not-highlighted">
        {{ 'MAINTENANCES.TABS.PRODUCTS.TOTAL_VALUE' | translate }}
      </h4>
      <h4 class="tab-services__body__value__highlighted">R${{ maintenance.totalValue || 0 | numberFormat }}</h4>
    </div>

    <ng-container *ngIf="filteredProducts?.items?.length && !loadingProducts">
      <div class="tab-products__body__table">
        <table class="tab-products__body__table__content">
          <thead class="tab-products__body__table__content__header">
            <tr class="tab-products__body__table__content__header__row">
              <th (click)="orderByName()">
                <span>{{ 'MAINTENANCES.TABS.PRODUCTS.TABLE.NAME' | translate }}</span>
                <mat-icon [ngClass]="orderBy === 'name_asc' ? 'name-asc' : 'name-desc'"> keyboard_arrow_down </mat-icon>
              </th>
              <th class="tab-products__body__table__content__header__row__storage">
                {{ 'MAINTENANCES.TABS.PRODUCTS.TABLE.STORAGE' | translate }}
              </th>
              <th>{{ 'MAINTENANCES.TABS.PRODUCTS.TABLE.QUANTITY' | translate }}</th>
              <th class="tab-products__body__table__content__header__row__value">
                {{ 'MAINTENANCES.TABS.PRODUCTS.TABLE.UNIT_VALUE' | translate }}
              </th>
              <th class="tab-products__body__table__content__header__row__total-value">
                {{ 'MAINTENANCES.TABS.PRODUCTS.TABLE.TOTAL_VALUE' | translate }}
              </th>
            </tr>
          </thead>
          <tbody class="tab-products__body__table__content__items">
            <tr *ngFor="let product of filteredProducts.items" class="tab-products__body__table__content__items__row">
              <td class="tab-products__body__table__content__items__row__cell--image-name">
                <div
                  *ngIf="!product.item.imageUrl"
                  class="tab-products__body__table__content__items__row__cell--image-name__default-image"
                >
                  <img src="assets/images/icons/mdi_office-building.svg" />
                </div>
                <div
                  *ngIf="product.item.imageUrl"
                  class="tab-products__body__table__content__items__row__cell--image-name__image"
                >
                  <img [src]="product.item.imageUrl" [alt]="product.item.name" />
                </div>
                <div class="tab-products__body__table__content__items__row__cell--image-name__name">
                  <span>
                    {{ product.item.name }}
                  </span>
                  <span class="tab-products__body__table__content__items__row__cell--image-name__name__measure">
                    ({{ 'MAINTENANCES.TABS.PRODUCTS.MEASURE.' + product.item.measure | translate }})
                  </span>
                </div>
              </td>
              <td class="tab-products__body__table__content__items__row__cell--storage-name">
                <span>
                  {{ (product.storage && product.storage.name) || '-' }}
                </span>
              </td>
              <td>{{ product.quantity }}</td>
              <td>R${{ product.value | numberFormat }}</td>
              <td class="tab-products__body__table__content__items__row__cell--total-value">
                R${{ product.quantity * product.value | numberFormat }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tab-products__body__table__navigation">
          <div class="tab-products__body__table__navigation__text">
            <p class="tab-products__body__paginate__title">
              {{
                'MAINTENANCES.TABS.PRODUCTS.PAGINATION.TITLE'
                  | translate
                    : {
                        limit:
                          paginationOffset + paginationLimit <= filteredProducts.totalCount
                            ? paginationOffset + paginationLimit
                            : filteredProducts.totalCount,
                        offset: paginationOffset + 1,
                        totalCount: filteredProducts.totalCount
                      }
              }}
            </p>
          </div>
          <button
            class="tab-products__body__table__navigation__button-previous"
            (click)="toPreviousPage()"
            [disabled]="!filteredProducts.pageInfo.hasPreviousPage || loadingProducts"
          >
            {{ 'MAINTENANCES.TABS.PRODUCTS.PAGINATION.PREVIOUS' | translate }}
          </button>
          <button
            class="tab-products__body__table__navigation__button-next"
            (click)="toNextPage()"
            [disabled]="!filteredProducts.pageInfo.hasNextPage || loadingProducts"
          >
            {{ 'MAINTENANCES.TABS.PRODUCTS.PAGINATION.NEXT' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="loadingProducts">
      <div class="tab-products__body__loading">
        <mat-spinner color="primary" diameter="64"></mat-spinner>
        <span>{{ 'MAINTENANCES.TABS.PRODUCTS.LOADING' | translate }}</span>
      </div>
    </ng-container>
    <div
      *ngIf="(!filteredProducts?.items?.length || !products?.items?.length) && !loadingProducts"
      class="tab-products__body__not-found"
    >
      <img src="assets/images/icons/ic_search_none_24px.svg" />
      <span *ngIf="!filteredProducts?.items?.length && products?.items?.length">
        {{ 'MAINTENANCES.TABS.PRODUCTS.NOT_FOUND' | translate }}
      </span>
      <span *ngIf="!services?.items?.length">
        {{ 'MAINTENANCES.TABS.PRODUCTS.LINKED_NOT_FOUND' | translate }}
      </span>
    </div>
  </div>
</form>
